module.exports = __webpack_public_path__ + "img/heart-dance.ad9864de.png";